import { Link } from "react-router-dom";
import { Users } from "lucide-react";

const legalLinks = [
  { to: "/legal/terms", label: "Terms of Service" },
  { to: "/legal/privacy", label: "Privacy Policy" },
  { to: "/legal/safety", label: "Safety & Conduct" },
  { to: "/legal/community", label: "Community Guidelines" },
  { to: "/legal/refund", label: "Cancellation & Refund" },
  { to: "/legal/host", label: "Host Agreement" },
  { to: "/legal/grievance", label: "Grievance Redressal" },
];

export default function Footer() {
  return (
    <footer className="bg-charcoal text-white mt-24">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-9 h-9 rounded-full bg-terracotta flex items-center justify-center">
              <Users className="w-5 h-5 text-white" />
            </div>
            <span className="font-display text-2xl font-bold">Saathly</span>
          </div>
          <p className="text-white/60 text-sm leading-relaxed">Verified people. Public places. Real conversations. A strictly platonic social platform for verified adults (18+).</p>
          <p className="text-white/40 text-xs mt-4">Bengaluru · Mumbai · Delhi & NCR · INR</p>
        </div>
        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-white/40 mb-4">Legal & Compliance</h4>
          <ul className="space-y-2">
            {legalLinks.map((l) => (
              <li key={l.to}><Link to={l.to} className="text-white/70 hover:text-sun text-sm transition-colors duration-200">{l.label}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-white/40 mb-4">Safety</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li>Public venues only</li>
            <li>Verified KYC for all users</li>
            <li>SOS & live location</li>
            <li>No sexual services — ever</li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-white/40 mb-4">Grievance Officer</h4>
          <p className="text-white/70 text-sm">Appointed under IT Rules 2021 & DPDP Act 2023.</p>
          <p className="text-sun text-sm mt-2">grievance@saathly.in</p>
          <Link to="/legal/grievance" className="text-white/70 hover:text-sun text-sm underline">Grievance Redressal page</Link>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-white/40 text-xs px-5">
        © 2026 Saathly (draft). Legal documents are drafts — verify with a licensed Indian lawyer. 18+ only.
      </div>
    </footer>
  );
}
